import { NavLink } from "react-router-dom";

export default function Sidebar() {
  const linkClasses =
    "block py-2.5 px-4 rounded-lg transition hover:bg-indigo-100";
  const activeClasses = "bg-indigo-600 text-white hover:bg-indigo-600";

  return (
    <aside className="w-56 h-screen border-r border-gray-200 p-4">
      <h2 className="text-xl font-bold mb-6">Admin Panel</h2>
      <nav className="space-y-2">
        <NavLink
          to="/factory"
          className={({ isActive }) =>
            `${linkClasses} ${isActive ? activeClasses : ""}`
          }
        >
          Factory Images
        </NavLink>
        <NavLink
          to="/products"
          className={({ isActive }) =>
            `${linkClasses} ${isActive ? activeClasses : ""}`
          }
        >
          Products
        </NavLink>
      </nav>
    </aside>
  );
}
